export const STATUS_LABEL = {
  new: "Order Baru",
  confirmed: "Dikonfirmasi",
  queue: "Menunggu Dirangkai",
  arranging: "Sedang Dirangkai",
  qc: "Siap QC",
  revision: "QC Gagal · Revisi",
  ready: "Siap Ambil/Kirim",
  waiting_pickup: "Menunggu Diambil",
  assigned_delivery: "Kurir Ditugaskan",
  out_for_delivery: "Dalam Pengiriman",
  failed_delivery: "Kirim Gagal",
  delivered: "Diterima/Diambil",
  completed: "Selesai",
  cancelled: "Batal",
  ready_delivery: "Siap Dikirim",
  ready_pickup: "Siap Diambil",
};

// tailwind-ish badge classes per status
export const STATUS_BADGE = {
  new: "bg-slate-100 text-slate-700",
  confirmed: "bg-sky-100 text-sky-700",
  queue: "bg-sky-100 text-sky-700",
  arranging: "bg-amber-100 text-amber-700",
  qc: "bg-emerald-100 text-emerald-700",
  revision: "bg-rose-100 text-rose-700",
  ready: "bg-green-100 text-green-700",
  waiting_pickup: "bg-green-100 text-green-700",
  assigned_delivery: "bg-sky-100 text-sky-700",
  out_for_delivery: "bg-amber-100 text-amber-700",
  failed_delivery: "bg-rose-100 text-rose-700",
  delivered: "bg-slate-100 text-slate-600",
  completed: "bg-slate-100 text-slate-600",
  cancelled: "bg-rose-100 text-rose-700",
};

export const PAYMENT_LABEL = { unpaid: "Belum Bayar", dp: "DP", paid: "Lunas" };
export const PAYMENT_BADGE = {
  unpaid: "bg-rose-100 text-rose-700",
  dp: "bg-amber-100 text-amber-700",
  paid: "bg-green-100 text-green-700",
};

export const PRIORITY_LABEL = { normal: "Normal", high: "Tinggi", urgent: "Mendesak" };
export const PRIORITY_BADGE = {
  normal: "bg-slate-100 text-slate-600",
  high: "bg-amber-100 text-amber-700",
  urgent: "bg-rose-100 text-rose-700",
};
